import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ContactsFilterApiInterface } from 'modules/mailing/email-statistics/types/email-statistics-filter-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const useContactsByEmail = email => {
  const $ = _c(8);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== email || $[2] !== user) {
    t1 = () => user && email && `${CONTACT_API}/contacts/email-list?email=${email}`;
    $[1] = email;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: contactsFilter,
    abort,
    isValidating
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[4] !== abort || $[5] !== contactsFilter || $[6] !== isValidating) {
    t2 = {
      contactsFilter,
      abort,
      isValidating
    };
    $[4] = abort;
    $[5] = contactsFilter;
    $[6] = isValidating;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};